import React, {Component} from 'react';
import {Button, Col, Container, Row, FormGroup, Label} from "reactstrap";
import selectn from 'selectn';
import AppActions from './../actions/AppActions';
import {get} from './../lib/http';
import notifier from './../lib/notifier';
import _ from 'lodash';
import ctrlS from "../lib/ctrlS";
import BoundTextInput from "./forms/BoundTextInput";
import {post} from "../lib/http";
import navigateTo from "../lib/navigateTo";
import BoundCheckbox from "./forms/BoundCheckbox";
import fetchLookups from "../lib/fetchLookups";
import BoundSelect from "./forms/BoundSelect";
import BoundDateInput from "./forms/BoundDateInput";

export class Incident extends Component {
    componentWillMount() {
        const id = selectn('match.params.id', this.props);

        this.update(id);
    }

    componentWillReceiveProps(nextProps) {
        const id = selectn('match.params.id', nextProps);
        if (id !== selectn('match.params.id', this.props)) {
            this.update(id);
        }
    }

    render() {
        const {incident} = this.props;

        const onKeyDown = (event) => {
            ctrlS(event, () => {
                this.save();
            });
        };

        return (
            <Container>
                <h1>Incident</h1>

                {incident && <div onKeyDown={onKeyDown}>

                    <FormGroup row>
                        <Label for="SiteName" sm={2}>Site name</Label>
                        <Col sm={4}>
                            {this.renderLookup('siteName', incident.siteName, siteName => this.fetchSiteLatLong(siteName))}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.siteName || ''} path="incident.siteName" id="SiteName"
                                            className="form-control input-md" maxLength="512" onChangeListener={siteName => this.fetchSiteLatLong(siteName)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="SiteType" sm={2}>Site type</Label>
                        <Col sm={4}>
                            {this.renderLookup('siteType', incident.siteType)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.siteType || ''} path="incident.siteType" id="SiteType"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="SiteLatitude" sm={2}>Site latitude</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.siteLatitude || ''} path="incident.siteLatitude" id="SiteLatitude"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="SiteLongitude" sm={2}>Site longitude</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.siteLongitude || ''} path="incident.siteLongitude"
                                            id="SiteLongitude"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="Region" sm={2}>Region</Label>
                        <Col sm={4}>
                            {this.renderLookup('region', incident.region)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.region || ''} path="incident.region" id="Region"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="Hazards" sm={2}>Hazards</Label>
                        <Col sm={4}>
                            {this.renderLookup('hazards', incident.hazards)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.hazards || ''} path="incident.hazards" id="Hazards"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="IncidentType" sm={2}>Incident type</Label>
                        <Col sm={4}>
                            {this.renderLookup('incidentType', incident.incidentType)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.incidentType || ''} path="incident.incidentType" id="IncidentType"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <Row form>
                        <Label for="IsInjury" sm={2}>Is injury</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundCheckbox checked={incident.isInjury} path="incident.isInjury" id="IsInjury"
                                           className="input-md"/>
                        </Col>
                    </Row>
                    <FormGroup row>
                        <Label for="IncidentRiskRating" sm={2}>Incident risk rating</Label>
                        <Col sm={4}>
                            {this.renderLookup('incidentRiskRating', incident.incidentRiskRating)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.incidentRiskRating || ''} path="incident.incidentRiskRating"
                                            id="IncidentRiskRating"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="ActivityTaskInvolved" sm={2}>Activity task involved</Label>
                        <Col sm={4}>
                            {this.renderLookup('activityTaskInvolved', incident.activityTaskInvolved)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.activityTaskInvolved || ''} path="incident.activityTaskInvolved"
                                            id="ActivityTaskInvolved"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="ConsequenceDescription" sm={2}>Consequence description</Label>
                        <Col sm={4}>
                            {this.renderLookup('consequenceDescription', incident.consequenceDescription)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.consequenceDescription}
                                            path="incident.consequenceDescription" id="ConsequenceDescription"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="Consequence" sm={2}>Consequence</Label>
                        <Col sm={4}>
                            {this.renderLookup('consequence', incident.consequence)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.consequence || ''} path="incident.consequence" id="Consequence"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="IncidentCategory" sm={2}>Incident category</Label>
                        <Col sm={4}>
                            {this.renderLookup('incidentCategory', incident.incidentCategory)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.incidentCategory || ''} path="incident.incidentCategory"
                                            id="IncidentCategory"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="IncidentSubCategory" sm={2}>Incident sub category</Label>
                        <Col sm={4}>
                            {this.renderLookup('incidentSubCategory', incident.incidentSubCategory)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.incidentSubCategory || ''} path="incident.incidentSubCategory"
                                            id="IncidentSubCategory"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="IncidentLevel" sm={2}>Incident level</Label>
                        <Col sm={4}>
                            {this.renderLookup('incidentLevel', incident.incidentLevel)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.incidentLevel || ''} path="incident.incidentLevel"
                                            id="IncidentLevel"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="InjuryType" sm={2}>Injury type</Label>
                        <Col sm={4}>
                            {this.renderLookup('injuryType', incident.injuryType)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.injuryType || ''} path="incident.injuryType" id="InjuryType"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="InjuryTypeShort" sm={2}>Injury type short</Label>
                        <Col sm={4}>
                            {this.renderLookup('injuryTypeShort', incident.injuryTypeShort)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.injuryTypeShort || ''} path="incident.injuryTypeShort"
                                            id="InjuryTypeShort"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="InjuryBodyPart" sm={2}>Injury body part</Label>
                        <Col sm={4}>
                            {this.renderLookup('injuryBodyPart', incident.injuryBodyPart)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.injuryBodyPart || ''} path="incident.injuryBodyPart"
                                            id="InjuryBodyPart"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="InjuryConsequence" sm={2}>Injury consequence</Label>
                        <Col sm={4}>
                            {this.renderLookup('injuryConsequence', incident.injuryConsequence)}
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.injuryConsequence || ''} path="incident.injuryConsequence"
                                            id="InjuryConsequence"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label for="IncidentCount" sm={2}>Incident count</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.incidentCount} path="incident.incidentCount"
                                            id="IncidentCount"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="InjuryCount" sm={2}>Injury count</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundTextInput value={incident.injuryCount} path="incident.injuryCount" id="InjuryCount"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label for="IncidentDate" sm={2}>Incident date</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundDateInput value={incident.incidentDate} path="incident.incidentDate" id="IncidentDate"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="ReportedDate" sm={2}>Reported date</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundDateInput value={incident.reportedDate} path="incident.reportedDate" id="ReportedDate"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="ActualDate" sm={2}>Actual date</Label>
                        <Col sm={4}>
                        </Col>
                        <Col sm={6}>
                            <BoundDateInput value={incident.actualDate} path="incident.actualDate" id="ActualDate"
                                            className="form-control input-md" maxLength="512"/>
                        </Col>
                    </FormGroup>

                    <div className="form-group">
                        <Button color="primary" className="float-right" onClick={() => this.save()}>Save</Button>
                    </div>

                </div>}
            </Container>
        );
    }

    fetchSiteLatLong(siteName) {
        const {lookups} = this.props;

        const siteNames = lookups.siteName;

        if (_.includes(siteNames, siteName)) {
            get(
                'api/incidents/latlong',
                {siteName},
                data => {
                    AppActions.updateStates([
                        {statePath: 'incident.siteLatitude', data: data.lat},
                        {statePath: 'incident.siteLongitude', data: data.long}
                    ]);
                });
        }
    }

    renderLookup(property, value, onSelectedCallback) {
        const {lookups} = this.props;

        const onSelected = newValue => {
            AppActions.updateStates([
                {statePath: `incident.${property}`, data: newValue}
            ]);

            if (_.isFunction(onSelectedCallback)) {
                onSelectedCallback(newValue);
            }
        };

        const lookupOptions = _.map(lookups && lookups[property], lookup => ({
            value: lookup,
            text: lookup
        }));

        const options = [{value: '', text: '<SELECT>'}, ...lookupOptions];

        return <BoundSelect
            path={`incident.${property}`}
            value={_.isNull(value) ? '' : value}
            onSelected={onSelected}
            options={options}/>;
    }

    save() {
        const {incident} = this.props;

        const isNew = incident.id === null;

        const onSaved = (content) => {
            // NOTE: Clear lookups so they are refreshed
            AppActions.updateStates([
                {statePath: 'lookups', data: null}
            ]);

            if (isNew) {
                notifier.notify({
                    level: notifier.Level.Success,
                    title: 'Success',
                    message: 'Incident created'
                });

                navigateTo(`/incident/${content.id}`);
                return;
            }

            notifier.notify({
                level: notifier.Level.Success,
                title: 'Success',
                message: 'Incident updated'
            });

            this.update(incident.id);
        };

        post('api/incidents', incident, onSaved);
    }

    update(id) {
        const {lookups} = this.props;

        if (!lookups) {
            fetchLookups();
        }

        if (id === '_') {
            const incident = {
                id: null,
                siteName: '',
                siteType: '',
                siteLatitude: '',
                siteLongitude: '',
                region: '',
                hazards: '',
                incidentType: '',
                isInjury: false,
                incidentRiskRating: '',
                activityTaskInvolved: '',
                consequenceDescription: '',
                consequence: '',
                incidentCategory: '',
                incidentSubCategory: '',
                incidentLevel: '',
                injuryType: '',
                injuryTypeShort: '',
                injuryBodyPart: '',
                injuryConsequence: '',
                incidentCount: 1,
                injuryCount: 0,
                incidentDate: '',
                reportedDate: '',
                actualDate: ''
            };

            setTimeout(() => AppActions.updateStates([
                {statePath: 'incident', data: incident}
            ]), 0);

            return;
        }

        get(
            'api/incidents/:id',
            {id},
            data => {
                AppActions.updateStates([
                    {statePath: 'incident', data: data}
                ]);
            });
    }
}